import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "@needl-ai/common/lib/axios";

import type { SuggestedPromptsResponse } from "@/types/suggestedPrompts";

export const SUGGESTED_PROMPTS_QUERY_KEY = "chat-suggested-prompts";

const API_ROUTES = {
  suggestedPrompts: () => `/chat/suggested-prompts`,
};

export const useFetchSuggestedPrompts = () => {
  return useQuery({
    queryKey: [SUGGESTED_PROMPTS_QUERY_KEY],
    queryFn: async () => {
      const response = await axiosInstance.get<SuggestedPromptsResponse>(
        API_ROUTES.suggestedPrompts()
      );
      return response;
    },
    select: (data) => data?.data?.categories ?? [],
    staleTime: Infinity,
  });
};
